import React from 'react';
import { Container, Row, Col, Card, Image, ListGroup, Button } from 'react-bootstrap';
import Header from './Header';
import Footer from './Footer';
import RecentPost from './RecentPost';


const GaneshChaturthi = () => {
  return (
    <>
    <Header />
    <div className="full-div" id="blog">
    <Container fluid className="main-sec">
      <Row>
        <Col sm={2}></Col>
        <Col sm={7} className="bg-white p-4 div-shadow mb-3">
          <h1 className="head-color">Ganesh Chaturthi 2024: Celebrate the Festival of Lord Ganesha with Joy and Devotion</h1>
          <span className="small ms-2"><b>Publish By:-</b> CodeInputs</span>
          <Row className="mt-3">
            <Col md={12}>
              <Image src="/graphics/images/ganesh2.webp" alt="ganesh chaturthi" fluid />
              <p className="mt-4">
               <b>Ganesh Chaturthi 2024</b> will start from <b>6th september</b> and end on <b>17 september</b>.Celebrates the birth of Lord Ganesha, the elephant-headed god of wisdom, prosperity, and remover of obstacles.The festival marks the arrival of Ganesha to the earthly realm and his return to his divine abode, symbolizing the cycle of creation and dissolution.People install beautifully crafted Ganesha idols in their homes and public spaces. Idols can vary in size and material, from clay to eco-friendly options.
              </p>
              <p>
                Devotees perform elaborate pooja (worship) ceremonies, offering sweets (especially modaks), flowers, and prayers. Traditional songs and hymns dedicated to Ganesha are sung.Homes and streets are decorated with vibrant lights, flowers, and rangoli (colorful patterns made on the floor).
              </p>
              <p>
                  On the final day, grand processions are organized, where the Ganesha idols are carried through streets accompanied by music, dance, and devotional chants.The idols are immersed in water bodies, such as rivers or seas, symbolizing the return of Ganesha to his heavenly abode. Efforts are increasingly being made to ensure that immersion practices are eco-friendly.
                </p>

                <p>Various community events and cultural programs are organized, including dance performances, dramas, and art exhibitions related to the festival.Different regions have their own unique ways of celebrating, showcasing regional art forms, and cultural practices.</p>

              <h4 className="sub-heads mb-5 mt-5">Happy Ganesh Chaturthi 2024: Greetings And Wishes</h4>
              <ul className="lh-large"><li>May the Divine Blessings of Ganesh Chaturthi Fill Your Life with Joy and Success.</li><br/>
                <li>Warm Wishes for Ganesh Chaturthi: May Lord Ganesha Remove All Obstacles in Your Path.</li><br/>
                <li>Ganesh Chaturthi Wishes: Celebrate with Joy and Let Lord Ganesha Guide Your Way.</li><br/>
                <li>Happy Ganesh Chaturthi: May the Spirit of Ganpati Bring Peace and Prosperity to Your Home.</li><br/>
                <li>Sending Joyful Ganesh Chaturthi Wishes: May Lord Ganesha’s Blessings Enrich Your Life.</li><br/>
                </ul>

                <img src="/images/ganesha_img.webp" width="100%" alt="ganesh chaturthi"/><br/><br/>
                <img src="/images/ganesha_wish.webp" width="100%" alt="ganesh chaturthi"/><br/><br/>
                <img src="/images/ganpati.webp" width="100%" alt="ganesh chaturthi"/><br/><br/>
                <img src="/images/ganesha.webp" width="100%" alt="ganesh chaturthi"/><br/><br/>
                <img src="/images/ganesh-chaturthi.webp" width="100%" alt="ganesh chaturthi"/><br/><br/>
              
              <div className="text-center mt-4">
                <Button variant="danger" href="https://youtu.be/769Wge9IEy4" target="_blank">Watch more on Ganesh Chaturthi</Button>
              </div>
            </Col>
          </Row>
        </Col>
        <Col sm={3} className="recent-post">
          <Card className="bg-white p-4 mb-3 div-shadow">
            <h4 className="head-color mt-4">Recent Post</h4>
            <RecentPost/>
          </Card>
          <Card className="bg-white p-4 div-shadow">
            <h4 className="head-color mt-4">Recent Comment</h4>
            <Card.Text style={{ color: '#85929e' }}>No Comments to Show</Card.Text>
          </Card>
        </Col>
      </Row>
    </Container>
    </div>
    <Footer />
    </>
  );
};

export default GaneshChaturthi;
